import {gql} from '@apollo/client';

export const GET_MICRO_PARTS_TAX_CODES = gql`
    query MicroPartsTaxCodes{
        fix:getAllFixes{
            id
            name
        }
        taxCodes:getTaxCodes{
            id
            code
            type
        }
    }
`;

export const SET_FIREBASE_TOKEN = gql`
    mutation setDeviceRegistrationToken($token: String!) {
        setDeviceRegistrationToken(token: $token){
            success
        }
    }
`;

export const REMOVE_FIREBASE_TOKEN = gql`
    mutation removeDeviceRegistrationToken($token: String!) {
        removeDeviceRegistrationToken(token: $token){
            success
        }
    }
`;

export const GET_NOTIFICATION_COUNT = gql`
    query getNotificationCount($filters: [FilterInputType!], $entityId: String!) {
        getNotificationCount(filters: $filters, entityId: $entityId)
    }
`;

export const GET_NOTIFICATION_COUNT_FOR_REFURB = gql`
    query getNotificationCount {
        getNotificationCount
    }
`;